import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import { getStyles } from './styled';

export const CustomTooltip = styled(
  ({
    className,
    mode,
    title,
    arrow = true,
    onOpen,
    open,
    enterDelay,
    enterNextDelay,
    leaveDelay,
    placement,
    width,
    disableHoverListener,
    height,
    testId,
    children,
    onClose = () => {},
    onMouseLeave,
    onMouseEnter,
    sx
  }) => (
    <Tooltip
      data-testid={testId}
      width={width}
      onClose={onClose}
      height={height}
      title={title}
      arrow={arrow}
      onOpen={onOpen}
      open={open}
      enterDelay={enterDelay}
      enterNextDelay={enterNextDelay}
      leaveDelay={leaveDelay}
      placement={placement}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      disableHoverListener={disableHoverListener}
      sx={sx}
      classes={className || mode ? { popper: `${className} ${mode}` } : undefined}>
      {children}
    </Tooltip>
  )
)(({ width, height, maxHeight, maxWidth, mode, sx }) => getStyles({ width, height, maxHeight, maxWidth, mode, sx }));

CustomTooltip.propTypes = {
  className: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.node,
  arrow: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  placement: PropTypes.oneOf([
    'bottom-end',
    'bottom-start',
    'bottom',
    'left-end',
    'left-start',
    'left',
    'right-end',
    'right-start',
    'right',
    'top-end',
    'top-start',
    'top'
  ]),
  mode: PropTypes.oneOf(['dark-mode', 'light-mode']),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  enterDelay: PropTypes.number,
  enterNextDelay: PropTypes.number,
  leaveDelay: PropTypes.number,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.shape({}),
  maxHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disableHoverListener: PropTypes.bool
};
